<template>
  <v-dialog persistent max-width="300px" v-model="dialog">
    <v-card>
      <v-card-title>
        <v-spacer style="text-align:center;">
          Вы уверены?
<!--          <div style="font-size:.75em; color: #666;">Вы уверены?</div>-->
        </v-spacer>
      </v-card-title>
      <v-card-actions class="pb-4">
        <v-spacer/>
          <v-btn :loading="loading" @click="confirm" color="primary" outlined dense>Подтвердить</v-btn>
          <v-btn :disabled="loading" @click="close" color="primary" dense>Отмена</v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    value: Function,
  },
  computed: {
    dialog: {
      get() {
        return !!this.value;
      },
      set(val) {
        if (!val) this.$emit('input')
      }
    }
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    close() {
      this.dialog = false;
      this.loading = false;
    },
    confirm() {
      this.loading = true;
      this.value().finally(this.close)
    }
  }
}
</script>

<style scoped>

</style>